import type { ServiceWeekDecisionTrail as Trail } from "../data/service-week-decisions";
import { formatServiceWeekInstant, serviceWeekCopy, serviceWeekDecisionCopy } from "../lib/service-week";

export function ServiceWeekDecisionTrail({ trail, timeZone }: { trail: Trail; timeZone: string }) {
  return <details className="service-week__trail">
    <summary>Decision trail{trail.status === "ok" ? ` · ${trail.rows.length}` : ""}</summary>
    <p className="service-week__muted">Internal authorized read · Newest first · {timeZone}</p>
    {trail.status === "empty" ? <p>{serviceWeekCopy.trailEmpty}</p> : <ol>
      {trail.rows.map((row) => {
        const prior = row.supersedesRowOrdinal === null ? null : trail.rows.find((item) => item.rowOrdinal === row.supersedesRowOrdinal);
        return <li key={row.rowOrdinal} className="service-week__fact">
          <h5>{serviceWeekDecisionCopy[row.act]}</h5>
          <p>{row.personLabel !== null ? `${row.personLabel} · ` : ""}<time dateTime={row.decidedAt}>{formatServiceWeekInstant(row.decidedAt, timeZone)}</time> · {timeZone}</p>
          <p>{row.serviceDay === null ? "Entire selected week" : `${row.serviceLabel} · ${row.serviceDay}`}</p>
          <p>{row.reasonVisibility === "verbatim" ? row.reason : row.act === "approved_week" || row.act === "included_candidate" || row.act === "marked_reviewed" ? "No reason required" : "reason on file"}</p>
          {prior ? <p className="service-week__muted">Supersedes {serviceWeekDecisionCopy[prior.act].toLowerCase()} recorded {formatServiceWeekInstant(prior.decidedAt, timeZone)}. The prior fact remains on the record.</p> : null}
        </li>;
      })}
    </ol>}
  </details>;
}
